export default {
  namespaced: true,
  state: {
    excelList: [],
    previewRow: {
      id: ''
    },
    nodeData: {},
    currentNode: null,
    currentNodeEdgesData: {
      incomeEdgesData: [],
      outgoingEdgesData: []
    },
    bottomHeight: 0,
  },
  mutations: {
    updateStateByKey(state, payload) {
      state[payload.key] = payload.value
    }
  },
  actions: {
  },
  getters: {
    excelList: state => state.excelList,
    previewRow: state => state.previewRow,
    nodeData: state => state.nodeData,
    currentNode: state => state.currentNode,
    incomeEdgesData: state => state.currentNodeEdgesData.incomeEdgesData,
    outgoingEdgesData: state => state.currentNodeEdgesData.outgoingEdgesData,
    currentNodeEdgesData: state => state.currentNodeEdgesData,
    bottomHeight: state => state.bottomHeight
  }
}



// WEBPACK FOOTER //
// ./src/store/l-etl.js